"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Landscaping() {
  const intro = useRevealOnScroll<HTMLDivElement>();
  const cards = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    eyebrow: "01",
    name: "Full diagnostics and repair",
    problem: "Not sure what's wrong? We'll run a full check and give you an honest assessment before any work begins.",
    outcomes: [],
    href: "/LawnMowerServicingRepairsInCarlisleCumbriaPage"
  }, {
    eyebrow: "02",
    name: "Blade sharpening and replacement",
    problem: "A sharp blade is everything on a ride on mower. We sharpen or replace blades to give your lawn a clean, even cut rather than a ragged tear.",
    outcomes: [],
    href: "/LawnMowerServicingRepairsInCarlisleCumbriaPage"
  }, {
    eyebrow: "03",
    name: "Engine servicing and tuning",
    problem: "We service and tune petrol engines to restore power and reliability.",
    outcomes: [],
    href: "/RideOnMowerServicingRepairsPage"
  }, {
    eyebrow: "04",
    name: "Carburettor cleaning and adjustment (petrol models)",
    problem: "Spluttering, stalling, or struggling to start? A blocked or poorly set carburettor is often the culprit. We clean and adjust it to get your engine running properly again.",
    outcomes: [],
    href: "/RideOnMowerServicingRepairsPage"
  }, {
    eyebrow: "05",
    name: "Oil change and general maintenance",
    problem: "Regular oil changes and general upkeep keep your petrol mower running efficiently and help avoid costly repairs down the line.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "06",
    name: "Drive system and wheel repairs",
    problem: "For self-propelled mowers, a faulty drive system makes the whole machine a chore. We repair drive cables, belts, and wheels to restore smooth operation.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "07",
    name: "Battery and electrical system checks",
    problem: "We test and inspect batteries, starter motors, and electrical connections to make sure everything fires up reliably.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "08",
    name: "Complete seasonal servicing",
    problem: "Our full seasonal service gets your ride-on mower ready for the cutting season ahead — or properly put to bed at the end of it.",
    outcomes: [],
    href: "#"
  }];
  return <section data-section-id="18605" id="lawnmowerservices" className="bg-background border-t-[1.5px] border-border py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-14">
        <div className="flex flex-col items-center">
          
          <div className="w-full max-w-3xl mx-auto text-center mb-16">
            <div ref={intro.ref} className={`transition-all duration-[480ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              
              <h2 className="font-default text-foreground leading-[1.02] mb-8" style={{
              fontSize: "clamp(2rem, 4.2vw, 3.75rem)",
              letterSpacing: "-0.03em"
            }}>
                <span className="font-extrabold">Ride-On Lawn Mower Services</span>
              </h2>
              <p className="font-default text-muted-foreground leading-[1.55] mb-10" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
              letterSpacing: "-0.005em"
            }}>
                Our services include:
              </p>
              <Link to="/AboutPage"></Link>
            </div>
          </div>

          
          <div ref={cards.ref} className="w-full max-w-4xl mx-auto">
            <div className="flex flex-col">
              {departments.map((dept, i) => <article key={dept.name} data-index={i} style={{
              transitionDelay: `${i * 80}ms`,
              marginTop: i === 0 ? 0 : "-1.5px"
            }} className={`group relative bg-card border-[1.5px] border-border p-9 md:p-11 transition-all duration-[480ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:border-primary hover:py-[2.75rem] md:hover:py-[3.5rem] hover:relative hover:z-10 ${cards.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                  <div className="flex flex-col gap-6">
                    <div className="flex items-start justify-between gap-4">
                      <p className="font-mono text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground">
                        {dept.eyebrow}
                      </p>
                    </div>

                    <h3 className="font-default font-bold text-foreground" style={{
                  fontSize: "clamp(1.75rem, 2.6vw, 2.25rem)",
                  letterSpacing: "-0.025em",
                  lineHeight: "1.05"
                }}>
                      {dept.name}
                    </h3>

                    <p className="font-default text-foreground/85 leading-[1.5]" style={{
                  fontSize: "clamp(1rem, 1.05vw, 1.125rem)"
                }}>
                      {dept.problem}
                    </p>

                    {dept.outcomes.length > 0 && <ul className="flex flex-col gap-3 mt-2">
                        {dept.outcomes.map((outcome, j) => <li data-index={j} key={j} className="flex items-start gap-3 font-default text-foreground text-base leading-[1.55]">
                            <span className="mt-2 inline-block size-2 shrink-0 bg-primary" aria-hidden="true" />
                            <span>{outcome}</span>
                          </li>)}
                      </ul>}

                    <div className="flex justify-end mt-2">
                      <Link to={dept.href} className="inline-flex items-center gap-2 font-default font-semibold text-sm text-primary underline underline-offset-[6px] decoration-[1.5px] hover:decoration-[2.5px] transition-all duration-200">
                        
                        
                      </Link>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}